import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CambioPswValidators } from 'src/app/core/services/cambioPswValidators';
import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { UserManager } from '../../services/user-manager';
import { HelpersService } from '../../services/helpers.service';
import { ModalNotifyService } from '../../services/modal-notify.service';

@Component({
  selector: 'main [profilo-utente]',
  templateUrl: './profilo-utente.component.html',
  styleUrls: ['./profilo-utente.component.css'],
  host: { '[attr.id]': '\'content\'' }
})
export class ProfiloUtenteComponent implements OnInit {

  changePwdForm: FormGroup;
  private http: HttpClient;
  messageError:boolean;
  messageSuccess:boolean;
  currentPwd: AbstractControl;
  newPwd: AbstractControl;
  confirmPwd: AbstractControl;
  attachment: string | null = null;
  fileName: string = '';
  canUserChangePassword: 'true' | 'false' = null;
  downloadForm: FormGroup;

  constructor(private fb: FormBuilder, private router: Router,  private userManager: UserManager, http: HttpClient, private helperService: HelpersService,private modalNotifyService: ModalNotifyService) {
    this.http = http;
    this.helperService = helperService;
  }

  ngOnInit() {
    this.changePwdForm = this.fb.group({
      currentPwd: ['', Validators.required],
      newPwd: ['', Validators.required],
      confirmPwd: ['', Validators.required]
  }, {
      validator: Validators.compose([
          CambioPswValidators.newMatchesConfirm,
          CambioPswValidators.newIsNotOld
      ]),
  });
    this.getParametroCambioPassword();
    this.currentPwd = this.changePwdForm.controls['currentPwd'];
    this.newPwd = this.changePwdForm.controls['newPwd'];
    this.confirmPwd = this.changePwdForm.controls['confirmPwd'];
     // --- download form ---
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const yesterdayTimestamp = yesterday.getTime();

    this.downloadForm = this.fb.group({
      startDate: [yesterdayTimestamp, Validators.required],
      endDate: [yesterdayTimestamp, Validators.required]
    })
  }

  save() {
    if (this.changePwdForm.valid) {
      const currentPwd = this.changePwdForm.controls['currentPwd'].value;
      const newPwd = this.changePwdForm.controls['newPwd'].value;
      
      this.http.put(ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_PATH_CHANGEPWD, { currentPwd, newPwd })
        .subscribe({
          next: () => {
            this.messageSuccess = true;
            this.changePwdForm.reset();
          },
          error: () => {
            this.messageError = true;
          }
        });
    }
  }
  

  getParametroCambioPassword() {
    this.userManager.getParametriCambioPwd().subscribe({
      next: response => this.canUserChangePassword = response.valore,
      error: () => this.canUserChangePassword = null
    });
  }

    

  downloadCSV(startDate: string, endDate: string) {
    if (!this.downloadForm.valid) {
      this.modalNotifyService.messaggioCustom('Seleziona entrambe le date.', 'Attenzione');
      return;
    }
    this.helperService.downloadCSV(startDate,endDate).subscribe({
      next: (response) => {
        const blob = new Blob([response.body], { type: 'text/csv' });
        if (blob.size === 0) {
          this.modalNotifyService.messaggioCustom('Non è possibile scaricare il file in quanto non esistono nuovi fascicoli creati.', 'Attenzione');
          return;
        }
        const filename = response.headers.get('content-disposition')?.split('filename=')[1] ?? 'download.csv';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: (error) => {
        console.error('Errore durante il download del CSV:', error);
      }
    });
  }
   
  
}
